export const usePdfPreview = () => useState<string | undefined>('pdfSource', () => undefined)
